module.exports = {"transport":"http","websocket":"wss://api.hive.blog:8090","uri":"https://api.hive.blog","url":"https://api.hive.blog","dev_uri":"","stage_uri":"","address_prefix":"STM","chain_id":"beeab0de00000000000000000000000000000000000000000000000000000000","alternative_api_endpoints":["https://api.hive.blog","https://api.ha.deathwing.me"],"failover_threshold":3,"useAppbaseApi":true}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1